<template>
  <el-card>
    <div slot="header">
      Hiány
    </div>
    <el-table
      :data="lack"
    >
      <el-table-column
        prop="product"
        label="Termék"
        show-overflow-tooltip
        width="220"
      />
      <el-table-column
        prop="count"
        label="Mennyiség"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.count }}
        </template>
      </el-table-column>
      <el-table-column
        prop="pack_type"
        label="Kiszerelés"
        width="120"
      />
      <el-table-column
        prop="price"
        label="Nettó ár"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.price | currency}}
        </template>
      </el-table-column>
      <el-table-column
        prop="unit_price"
        label="Egységár"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.unit_price }} ft
        </template>
      </el-table-column>
      <el-table-column
        prop="comment"
        label="Megjegyzés"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.comment">{{ scope.row.comment }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>
<script>
  export default {
    props: ['stockTakingLack'],
    data() {
      return {
        lack: [],
      }
    },
    watch: {
      stockTakingLack(newVal) {
        this.lack = [...newVal];
      }
    },
    mounted() {
      if(this.stockTakingLack && this.stockTakingLack.length) {
        this.lack = [...this.stockTakingLack];
      }
    }
  }
</script>
